// Single constants
// TODO: [#defaultStyles] we need to move all default styles to 1 place
export const CallToActionLineHeightModifier = 1.2;
export const LIST_MAX_DEPTH = 4;

export enum EditorKeyBindingCommand {
  UNDO = 'undo_',
  REDO = 'redo',
  BACKSPACE = 'backspace',
}

export const SCRIPT_BASIC_FONT_REDUCTION = 0.75;

export enum ScriptType {
  SUPERSCRIPT = 'SUPERSCRIPT',
  SUBSCRIPT = 'SUBSCRIPT',
}

// TODO: [#defaultStyles] we need to move all default styles to 1 place
export enum DefaultCustomStyle {
  FONT_COLOR = '#000000',
  FONT_FAMILY = 'Arial',
  BRANT_FONT_NAME = 'BaseFont',
  FONT_SIZE = 14,
}

export enum FontFamily {
  CONDENSED = 'Condensed',
  ULTRA_CONDENSED = 'Ultra Condensed',
  EXTENDED = 'Extended',
}

export enum FontSizeLimit {
  MIN = 1,
  MAX = 72,
}

export const FontSizes: number[] = [8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];

export enum CharStyle {
  BOLD = 'bold',
  ITALIC = 'italic',
  UNDERLINE = 'underline',
}

export enum CharStyleValue {
  ITALIC = 'italic',
  NORMAL = 'normal',
  REGULAR = '400',
  BOLD = '700',
}
